import { ITrip } from "@src/containers/liveMapView/types";
import { ITripResponseType, TripStatus, NewTripStatus, NewTripResponse } from "./types";

export function convertNewTripResponseToITripResponse(
  tripResponse: NewTripResponse
): ITripResponseType {
  const { attributes: trip, id } = tripResponse;
  return {
    workerUserId: trip.workerId,
    shiftId: trip.shiftId,
    facilityId: trip.workplaceId,
    radarTripId: trip.locationProviderTripId ?? "",
    currentEtaDuration: trip.currentEtaDuration,
    currentEtaDistance: trip.currentEtaDistance,
    initialEtaDuration: trip.initialEtaDuration,
    initialEtaDistance: trip.initialEtaDistance,
    status: convertNewTripStatusToTripStatus(trip.status),
    latestWorkerMovement: trip.latestWorkerMovement,
    startTime: trip.tripStartTime,
    stopTime: trip.tripStopTime,
    updatedAt: trip.updatedAt,
    workerInputtedEta: trip.workerDeclaredEta,
    isLate: trip.isLate,
    id,
    createdAt: trip.createdAt,
    receivedAt: trip.lastLocationReceivedByServerAt,
  };
}

export function convertNewTripResponsesToITrips(tripResponses: NewTripResponse[]): ITrip[] {
  return tripResponses.map((tripResponse) => {
    const { attributes: trip, id } = tripResponse;
    return {
      workerUserId: trip.workerId,
      shiftId: trip.shiftId,
      etaDuration: trip.currentEtaDuration,
      status: convertNewTripStatusToTripStatus(trip.status),
      stopTime: trip.tripStopTime ?? null,
      updatedAt: trip.updatedAt,
      isLate: trip.isLate,
      id,
      latitude: trip.currentLatitude?.toString() ?? "0",
      longitude: trip.currentLongitude?.toString() ?? "0",
      radarTripId: trip.locationProviderTripId ?? "",
      currentEtaDuration: trip.currentEtaDuration,
      currentEtaDistance: trip.currentEtaDistance,
      initialEtaDuration: trip.initialEtaDuration,
      initialEtaDistance: trip.initialEtaDistance,
      latestWorkerMovement: trip.latestWorkerMovement,
      workerDeclaredEta: trip.workerDeclaredEta,
    };
  });
}

export function convertNewTripStatusToTripStatus(status: NewTripStatus): TripStatus {
  switch (status) {
    case "TRIP_ARRIVED":
      return TripStatus.TRIP_ARRIVED;
    case "TRIP_CANCELLED":
      return TripStatus.TRIP_CANCELLED;
    case "TRIP_EXPIRED":
      return TripStatus.TRIP_EXPIRED;
    case "TRIP_STARTED":
      return TripStatus.TRIP_STARTED;
    case "TRIP_APPROACHING":
      return TripStatus.TRIP_APPROACHING;
    case "TRIP_COMPLETED":
      return TripStatus.TRIP_COMPLETED;
    case "TRIP_PENDING":
    case "TRIP_PLACEHOLDER":
      return TripStatus.TRIP_PENDING;
    default:
      return TripStatus.TRIP_NO_INFORMATION;
  }
}
